export const SOLAR_SERIES_DATA = {
  ACTUAL_GENERATION: 'Actual Generation',
  ACTUAL_VS_EXPECTED_PERCENT: 'Actual vs Expected %',
  EXPECTED_GENERATION: 'Expected Generation',
  GRID_CONSUMED: 'Grid Consumed',
  SOLAR_CONSUMED: 'Solar Consumed',
  SOLAR_POWER_EXPORTED: 'Solar Power Exported',
  SOLAR_TO_BATTERY_TO_BUILDING: 'Solar to Battery to Building',
  SOLAR_TO_BATTERY_TO_GRID: 'Solar to Battery to Grid',
  SOLAR_TO_BUILDING: 'Solar to Building',
  SOLAR_TO_GRID: 'Solar to Grid',
};
